import React from 'react';
import { ProductCard } from '../../../CategoryPage/ProductCard';

const FeaturedProductCard = ({ product, imageSizes }) => {
  return <ProductCard product={product} imageSizes={imageSizes} as="div" />;
};

export default FeaturedProductCard;
